import React from "react";
import { string } from "yup";
import Input from "./Base";
export const schema = string().email("Please enter a valid email address.").required("An email address is required.");
export default React.forwardRef((props, ref) => /* @__PURE__ */ React.createElement(Input, {
  ref,
  label: "Email",
  type: "email",
  required: true,
  ...props
}));
